import { Buyer } from '@40seas/entities/buyers';
import { Charge } from '@40seas/entities/charges';
import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { PaymentMethod } from '@40seas/entities/payment-methods';
import { Seller } from '@40seas/entities/sellers';
import { BaseEntity, Currency, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { RefundStatus } from './refund.status.enum';

export const RefundSchema = WithBaseEntitySchema(
    z.object({
        charge: z.string().or(Charge['schema']),
        buyer: z.string().or(Buyer['schema']).openapi({ title: 'Buyer', description: 'Buyer' }),
        paymentMethod: z.string().or(PaymentMethod['schema']),
        providerId: z.string().optional(),
        status: EnumSchema(RefundStatus),
        amount: z.number(),
        currency: EnumSchema(Currency),
    }),
)
    .strict()
    .openapi({
        title: 'Refund',
    });

export class Refund extends FromSchema(RefundSchema) implements BaseEntity {
    id: string;
    charge: string | Charge;
    buyer: string | Buyer;
    paymentMethod: string | PaymentMethod;
    providerId?: string;
    status: RefundStatus;
    amount: number;
    currency: Currency;
    seller?: string | Seller;
    tenantId: string;
    createdAt?: Date;
    updatedAt?: Date;
    createdBy?: Executor;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
